// @flow
import * as React from "react"
import { hot } from "react-hot-loader"
import { Layout } from "../../components/Layout"
import { tRouteProps, tDefaultTemplate } from "../../types"
import { Container } from "../../components/StyledComponents"
import { css } from "emotion/macro"
import { Link } from "react-static"
import { FlexibleContent } from "../../components/FlexibleContent"
import { EventList } from "../../components/EventList"
import type { tCrmEvent } from "../../types"
import { PeopleSection, PersonList } from "../OurPeople"
import { PageMarquee } from "../../components/PageMarquee/index"
import Contact from "./Contact"
import Home from "./Home"
import ClassOfferings from "./ClassOfferings"
import CoreClasses from "./CoreClasses"
import AudioDownloads from "./AudioDownloads"
import CommunityGroups from "./CommunityGroups"
import VideoArchives from "./VideoArchives"
import { PageMeta } from "../../components/PageMeta"

export type tPage = tRouteProps &
  tDefaultTemplate & {
    title: string,
    neon: {
      events: {
        events: Array<tCrmEvent>
      }
    }
  }

export type tPageState = {}

export class Page extends React.Component<tPage, tPageState> {
  render() {
    return (
      <React.Fragment>
        <PageMeta
          title={this.props.title}
          description=""
          image={this.props.brand.logo}
        />
        {this.props.default_template_content && (
          <PageMarquee
            image={this.props.default_template_content.marquee_image}
          />
        )}
        <Container
          className={css`
            position: relative;
          `}
        >
          <ServicesAndEvents {...this.props} />
          {this.props.flexible_content && (
            <FlexibleContent items={this.props.flexible_content} />
          )}
          <PeopleSection>
            {this.props.slug === "prayer-practitioners" && (
              <React.Fragment>
                <h2 className="text-center">Prayer Practitioners</h2>
                <div
                  className={css`
                    margin-top: 30px;
                  `}
                >
                  <PersonList {...this.props} section="prayer_practitioner" />
                </div>
              </React.Fragment>
            )}
          </PeopleSection>
        </Container>
      </React.Fragment>
    )
  }
}

export type tServicesAndEvents = tPage

export type tServicesAndEventsState = {}

export class ServicesAndEvents extends React.Component<
  tServicesAndEvents,
  tServicesAndEventsState
> {
  render() {
    return this.props.slug === "services-and-events" ? (
      <React.Fragment>
        <div
          className={css`
            text-align: center;
            margin-top: 15px;
          `}
        >
          <Link className="btn btn-orange" to={"/events"}>
            Events Calendar
          </Link>
        </div>
        <div
          className={css`
            margin-top: 60px;

            h2 {
              text-align: center;
            }
          `}
        >
          <Container>
            <h2>Activities &amp; Events</h2>
            {this.props.neon.events.events.length > 0 && (
              <EventList
                items={this.props.neon.events.events.filter(
                  (event, i) => i < 6
                )}
              />
            )}
          </Container>
        </div>
      </React.Fragment>
    ) : null
  }
}

function RenderPage(props: tPage) {
  return (
    <Layout>
      {(routeProps) => {
        switch (routeProps.slug) {
          case "/":
          case "home":
            return <Home {...props} {...routeProps} />
          case "contact-us":
            return <Contact {...props} {...routeProps} />
          case "learn":
          case "class-offerings":
            return <ClassOfferings {...props} {...routeProps} />
          case "core-classes":
            return <CoreClasses {...props} {...routeProps} />
          case "audio-downloads":
            return <AudioDownloads {...props} {...routeProps} />
          // Wordpress wont let us rename community-groups slug to remove the -2... there are no other community group pages published or in the trash. I'm guessing this is some kind of WP 5.0 bug.
          case "community-groups":
          case "community-groups-2":
            return <CommunityGroups {...props} {...routeProps} />
          case "video-archives":
            return <VideoArchives {...props} {...routeProps} />
          default:
            return <Page {...props} {...routeProps} />
        }
      }}
    </Layout>
  )
}

export default hot(module)(RenderPage)



// WEBPACK FOOTER //
// /opt/build/repo/src/screens/Page/index.js